<template>
  <b-card no-body>
    <b-card-header class="pb-50">
      <h5>
        Selecciona el plan de estudio, periodo y curso (en ese orden) para  ver solo alumnos pertenecientes a ese grupo.
      </h5>
    </b-card-header>
    <b-card-body>
      <b-row>
        <b-col
          cols="12"
          md="6"
          class="mb-md-0 mb-2"
        >
          <label>Plan de Estudios</label>
          <v-select
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :value="(planFilter === null)?'Selecciona un plan de estudios':planFilter"
            :options="planes"
            label="nombre"
            :clearable="false"
            class="w-100 text-sm"
            :reduce="val => val.id"
            @input="(val) => $emit('update:planFilter', val)"
          >
            <span slot="no-options">Por el momento no tienes disponible esta opción</span>
          </v-select>
        </b-col>
        <b-col>
          Periodo:
          <v-select
            id="periodo"
            :options="periodos"
            :reduce="period => period.periodo"
            label="clave"
            :value="(periodoFilter === null)?'Selecciona un periodo válido':periodoFilter"
            filterable
            :clearable="true"
            @input="(val) => $emit('update:periodoFilter', val)"
          >
            <template #no-options>
              Selecciona primero el plan de estudios
            </template>
          </v-select>
        </b-col>
      </b-row>
      <b-row>
        <b-col
          cols="12"
          md="6"
          class="mb-md-0 mb-2"
        >
          <label>Cursos</label>
          <v-select
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :value="(cursosFilter=== null)?'Selecciona uno de tus cursos':cursosFilter"
            :options="cursos"
            label="nombre"
            class="w-100"
            :clearable="false"
            :disabled="deshabilitarCursos"
            :reduce="val => val.id"
            @input="(val) => $emit('update:cursosFilter', val)"
          >
            <span slot="no-options">Selecciona primero un periodo válido</span>
          </v-select>
        </b-col>
        <!-- rol de asesor es 4 -->
        <b-col
          v-show="cursosFilter && userRol.id == 4"
          cols="12"
          md="2"
          class="mb-md-0 mb-2 mt-2"
        >
          <b-button
            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
            variant="outline-primary"
            class="mb-75"
            @click="firmar()"
          >
            Firmar
          </b-button>
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard, BCardHeader, BCardBody, BRow, BCol, BButton,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import { rolesActions } from '@core/mixins/account-data/roles'
import hostname from '@core/utils/http/config-hostname'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    vSelect,
    BButton,
  },
  directives: {
    Ripple,
  },
  mixins: [rolesActions],
  props: {
    planFilter: {
      type: Number,
      default: 1,
    },
    cursosFilter: {
      type: Number,
      default: null,
    },
    periodoFilter: {
      type: Number,
      default: 0,
    },
    planes: {
      type: Array,
      required: true,
    },
    cursos: {
      type: Array,
      required: true,
    },
    statusOptions: {
      type: Array,
      required: true,
    },
    periodos: {
      type: Array,
      default() {
        return []
      },
    },
    deshabilitarCursos: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // FORMS
      selected: 0,
    }
  },
  methods: {
    firmar() {
      const config = 'menubar=yes,location=yes,resizable=yes,scrollbars=yes,status=yes,width=700,height=800'
      const routeData = `${hostname().host}/app/reporte-calificacion/${this.planFilter}/${this.cursosFilter}/${this.periodoFilter}`
      window.open(routeData, 'Configurar Facturacion', config)
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
